export default __webpack_public_path__ + "static/media/daniela_m.2fdaf8c5.jpg";